'use strict';

var util = require('./util');

module.exports = SchemaObject;

function SchemaObject(obj) {
  util.copy(obj, this);
}



//////////////////
// WEBPACK FOOTER
// ./~/ethpm-registry/~/ajv/lib/compile/schema_obj.js
// module id = 1255
// module chunks = 0 1